import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';

import {executionsService} from '@store/operations/executions/executions.service';
import {ExecutionsState} from '@store/operations/executions/executions.store';

type SearchExecutionParams = Partial<ExecutionsState>

export const searchExecutionEffect = createEffectFn((params$: Observable<SearchExecutionParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => executionsService.getExecutions().pipe(catchError(() => EMPTY))),
  );
});
